import React, { useEffect } from 'react';
import { GridColDef } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import CustomDataGrid from '../../../../components/ui/customDataGrid/customDataGrid.component';
import { JOB_STATUS_TRANSITION_ACTIONS_ENDPOINT, getJobStatusLabelKey } from '../../../../consts';
import styles from './tenantStatusTransitionActionsList.module.css';
import { useHasPermission } from '../../../../contexts/auth';
import { useBreadcrumbs } from '../../../../components/ui/breadcrumps/breadcrumbsContext';

export const TenantStatusTransitionActionsList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setOverride, clearOverride } = useBreadcrumbs();
  const canView = useHasPermission("service.view_jobstatustransitionaction");

  useEffect(() => {
    const path = '/tenant/status-transition-actions';
    setOverride(path, t('Status Transition Actions'));

    return () => {
      clearOverride(path);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t]);

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
    },
    {
      field: 'previous_status',
      headerName: t('Previous status'),
      valueGetter: (value: string) => {
        const labelKey = getJobStatusLabelKey(value);
        return labelKey ? t(labelKey) : value;
      },
    },
    {
      field: 'new_status',
      headerName: t('New status'),
      valueGetter: (value: string) => {
        const labelKey = getJobStatusLabelKey(value);
        return labelKey ? t(labelKey) : value;
      },
    },
    {
      field: 'required_fields',
      headerName: t('Required fields'),
      valueGetter: (value: unknown[]) => value?.length ?? 0,
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/tenant/status-transition-actions/${id}`);
  };

  if (!canView) {
    return null;
  }

  return (
    <Box className={styles.container}>
      <CustomDataGrid
        icon={<SyncAltIcon />}
        title={t('Status Transition Actions')}
        url={JOB_STATUS_TRANSITION_ACTIONS_ENDPOINT}
        gridSettingsKey="TENANT_STATUS_TRANSITION_ACTIONS"
        columns={columns}
        refreshEventName="statusTransitionActionsUpdated"
        onRowClick={handleRowClick}
      />
    </Box>
  );
};
